import type {
  AcceptUserInviteRequest,
  AcceptUserInviteResponse,
} from '../types/UserInviteTypes'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Accepts a pending invitation and adds the authenticated user to the workspace
 * This is a public endpoint (not workspace-scoped) for users who are not yet members
 * @param token - The unique invitation token from the email link
 * @returns Workspace details for the newly joined workspace
 * @throws Error if token is invalid, expired, or email doesn't match
 */
export async function acceptInvite(
  token: string,
): Promise<AcceptUserInviteResponse> {
  const request: AcceptUserInviteRequest = { token }

  const response = await AuthAxios.post<AcceptUserInviteResponse>(
    '/api/v1.0/invites/accept',
    request,
  )

  return response.data
}
